export default __webpack_public_path__ + "static/media/speakerOff.af7a432d.svg";